import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import * as moment from "moment";
import Swal from "sweetalert2";
import { DatePipe } from "@angular/common";
import CryptoJS from "crypto-js";
import { APP_CONFIG, IAppConfig } from "src/app/app.config";
import { PlyrComponent } from "ngx-plyr";
import { CommonService } from "src/app/services/common.service";
import { StorageService } from "../../services/storage.service";
@Component({
  selector: "app-student-video-search",
  templateUrl: "./student-video-search.component.html",
  styleUrls: ["./student-video-search.component.css"],
})
export class StudentVideoSearchComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  @ViewChild(PlyrComponent) plyr: PlyrComponent;
  page: number = 1;
  page_size: number = 10;
  StudentvideoList: any;
  Studentvideo: any;
  Studentvideo1 = [];
  Table_pagination: boolean;
  prolength: any;
  department: Object;
  dept: any;
  classroom: Object;
  class: any;
  subject: Object;
  subjectData: any;
  department_id: any;
  subject_id: any;
  classroom_id: any;
  htmlpageshow: boolean;
  page_count = [];
  total_count = 0;
  pagedItems: any[];
  total: number;
  p: number;
  showLoadMore = false;
  submitted = false;
  pageshow = true;
  filter: any;
  stufilter: boolean = true;
  filter_from: any;
  filter_end: any;
  batch: Object;
  batchData: any;
  batch_id: any;
  prodessor: Object;
  prodessorData: any;
  professor_id: any;
  videodec: any;
  showvideo = false;
  viewvideo = false;
  videosrc: any;
  dataindex: any;
  filter_date: any = [];
  searchForm: any;
  player: Plyr;
  isLoginType: boolean;
  departmentid: any;
  userid: any;
  batchid: any;
  professorid: any;
  profid: boolean = false;
  subjectlist: boolean;
  filtervalues: boolean;
  chiparray: any = [];
  is_student_search_all_video: string = "";
  hod: any;
  session_id: any;
  sessionData: any;
  findedVal: any;
  minDate: Date;
  maxDate = new Date();
  date: any;
  filterPopupend: any;
  filterPopupfrom: any;
  sessionName: any;
  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    public router: Router,
    public route: ActivatedRoute,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    private datepipe: DatePipe,
    @Inject(APP_CONFIG) private config: IAppConfig,
    public commonService: CommonService
  ) {}

  roleId = this.storageService.getRole();
  async ngOnInit() {
    this.maxDate = new Date();
    this.minDate = new Date();
    this.hod = this.storageService.getHod();
    this.is_student_search_all_video = this.ls.get(
      "is_student_search_all_video"
    );
    this.subjectlist = false;
    this.route.queryParams.subscribe((params) => {
      this.isLoginType = !!params["loginType"];
      this.globalService.loginType = params.loginType;
      if (params.loginType == "impersonate") {
        (this.roleId = this.ls.get("impersonate_role")),
          (this.department_id = this.ls.get("impersonate_department_id")),
          (this.batch_id = this.ls.get("impersonate_batch_id"));
      } else {
        this.roleId = this.storageService.getRole();
      }
    });

    this.searchForm = this.fb.group({
      id: [""],
      date: [""],
      depname: [""],
      subjectname: [""],
      proname: [""],
      departmentname: [""],
      batchname: [""],
      classname: [""],
      session: [""],
    });
    this.getDepartment();
    this.getSubject();
    this.getclassroom();
    this.getBatch();
    this.getProfessor();
    this.getSession();

    if (this.roleId == 5) {
      this.Filter(
      );
    }
  }

  played(event: Plyr.PlyrEvent) {}
  get forms1() {
    return this.searchForm.controls;
  }
  async getPage(page: number) {
    this.page = page;
    await this.getStudentvideoList();
    const res = await this.serverCall(this.Studentvideo, page);
    // this.total = this.total_count;
    this.p = page;
    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }

  // Filter() {
  //   this.filtervalues = true;
  //   this.chiparray = [];
  //   const formValue = this.searchForm.getRawValue();
  //   if(this.searchForm.controls['session']?.value) {
  //     this.chiparray.push(
  //       "Session : " + this.searchForm.controls['session']?.value
  //     );
  //   }
  //   if (this.filter != undefined && this.filter != "") {
  //     this.chiparray.push(
  //       "Date :" + " " + this.filter_from + " - " + this.filter_end
  //     );
  //   }
      
  //   if (this.searchForm.controls['proname']?.value) {
  //     var proffessor = this.prodessorData.filter(
  //       (x) => x.id == this.searchForm.controls['proname']?.value
  //     );
  //     this.chiparray.push(
  //       "Proff:" +
  //         " " +
  //         proffessor[0]?.first_name +
  //         " " +
  //         proffessor[0]?.last_name
  //     );
  //   }
  //   if (this.searchForm.controls['departmentname']?.value) {
  //     var dept = this.dept?.filter((x) => x.id == this.searchForm.controls['departmentname']?.value);
  //     this.chiparray.push("Dept:" + " " + dept[0].name);
  //   }

  //   if (this.searchForm.controls['subjectname']?.value) {
  //     var subject = this.subjectData.filter((x) => x.id == this.searchForm.controls['subjectname']?.value);
  //     this.chiparray.push("Subject:" + " " + subject[0].name);
  //   }
  //   if (this.searchForm.controls['batchname']?.value) {
  //     var Batch = this.batchData.filter((x) => x.id == this.searchForm.controls['batchname']?.value);
  //     this.chiparray.push("Batch:" + " " + Batch[0].batch);
  //   }

  //   if (this.searchForm.controls['classname']?.value) {
  //     var classroom = this.class.filter((x) => x.id == this.searchForm.controls['classname']?.value);
  //     this.chiparray.push("Class:" + " " + classroom[0].name);
  //   }
    
  //   this.pageshow = true;
  //   this.page = 1;
  //   this.getStudentvideoList();
  // }

  Filter() {
  this.filtervalues = true;
  this.chiparray = [];
 
  const formValue = this.searchForm.getRawValue();
 
  if (formValue.session) {
    this.chiparray.push("Session : " + formValue.session);
  }
 
  if (this.filter_from != undefined && this.filter_end != "") {
    this.chiparray.push(
      "Date :" + " " + this.filter_from + " - " + this.filter_end
    );
  }
 
  if (formValue.proname) {
    const professor = this.prodessorData.filter(
      (x) => x.id == formValue.proname
    );
 
    this.chiparray.push(
      "Proff: " +
      professor[0]?.first_name +
      " " +
      professor[0]?.last_name
    );
  }
 
  if (formValue.departmentname) {
    const dept = this.dept?.filter(
      (x) => x.id == formValue.departmentname
    );
 
    this.chiparray.push("Dept: " + dept[0]?.name);
  }
 
  if (formValue.subjectname) {
    const subject = this.subjectData.filter(
      (x) => x.id == formValue.subjectname
    );
 
    this.chiparray.push("Subject: " + subject[0]?.name);
  }
 
  if (formValue.batchname) {
    const batch = this.batchData.filter(
      (x) => x.id == formValue.batchname
    );
 
    this.chiparray.push("Batch: " + batch[0]?.batch);
  }
 
  if (formValue.classname) {
    const classroom = this.class.filter(
      (x) => x.id == formValue.classname
    );
 
    this.chiparray.push("Class: " + classroom[0]?.name);
  }
 
  this.pageshow = true;
  this.page = 1;
  this.getStudentvideoList();
}
 

  async onDepartmentChange() {
    const deptVal =
      this.searchForm.get("departmentname")?.value ||
      this.searchForm.get("depname")?.value;
    this.departmentid = deptVal || null;
    this.department_id = deptVal || null;
    this.professor_id = null;
    this.subject_id = null;
    this.searchForm.patchValue({
      proname: null,
      proffname: null,
      subjectname: null,
    });
    await this.getSubjectDropdown();
    await this.getProfessor();
  }

  async getSubjectDropdown() {
    const filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };

    const sessionVal = this.searchForm?.get("session")?.value;
    let sessionId = null;
    if (sessionVal && this.sessionData?.length) {
      const selectedSession = this.sessionData.find(s => s.session === sessionVal);
      sessionId = selectedSession?.id;
    } else if (this.findedVal?.id) {
      sessionId = this.findedVal.id;
    }

    if (sessionId) {
      filter.session_id = sessionId;
    }

    const departmentId =
      this.searchForm?.get("departmentname")?.value ||
      this.searchForm?.get("depname")?.value ||
      this.departmentid ||
      this.department_id;

    if (departmentId) {
      filter.department_id = departmentId;
    }

    const subject = await this.globalService.get(
      "subject/list/dropdown",
      filter,
      true
    );

    this.subjectData = subject["content"] || [];

    // Clear previously selected subject if not present in new list
    const currentSub = this.searchForm?.get("subjectname")?.value;
    if (currentSub && !this.subjectData.some((s: any) => s.id == currentSub)) {
      this.searchForm.patchValue({
        subjectname: null,
      });
      this.subject_id = null;
    }
  }

  async getProfessor(isInit: boolean = false) {
    this.Studentvideo = [];
    this.spinner.show();
    var startUTCDate = moment(this.filter_from, "YYYY-MM-DD");
    var endUTCDate = moment(this.filter_end, "YYYY-MM-DD");

    const departmentId =
      this.searchForm.get("departmentname")?.value ||
      this.searchForm.get("depname")?.value ||
      this.departmentid ||
      this.department_id;

    let filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    if (departmentId) {
      filter.department_id = departmentId;
    }

    this.prodessor = await this.globalService.get(
      "user/profeser/dropdown",
      filter,
      true
    );

    this.prodessorData = this.prodessor["content"] || [];

    if (this.professor_id) {
      const exists = this.prodessorData.find((x) => x.id == this.professor_id);
      if (!exists) {
        this.professor_id = null;
        this.searchForm.patchValue({
          proname: null,
          proffname: null,
        });
      }
    }

    if (isInit && !this.professor_id && this.roleId == 4) {
      let defaultProfId = this.ls.get("createdBy");
      this.route.queryParams.subscribe(params => {
        if (params.loginType == "impersonate") {
          defaultProfId = this.ls.get("impersonate_user_id");
        }
      });

      const profExists = this.prodessorData.find((x) => x.id == defaultProfId);
      if (profExists) {
        this.professorid = defaultProfId;
        this.professor_id = defaultProfId;
        this.profid = true;
        this.searchForm.patchValue({
          proname: defaultProfId,
        });

        if (profExists.department_id) {
          this.departmentid = profExists.department_id;
          this.department_id = profExists.department_id;
          this.searchForm.patchValue({
            departmentname: profExists.department_id,
            depname: profExists.department_id,
          });
        }
      }
    }

    this.spinner.hide();
  }

  async getSession() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    let session = await this.globalService.get(
      "session/dropdown",
      filter,
      true
    );
    this.sessionData = session["content"];
    this.chiparray.push(
      "Date :" +
        " " +
        moment(new Date()).format("YYYY-MM-DD") +
        " - " +
        moment(new Date()).format("YYYY-MM-DD")
    );

   if (session["status"] == 200) {
 
  this.departmentid = this.storageService.getDepartment();
  this.batchid = this.ls.get("batch_id");
 
  this.filter_from = moment(new Date()).format("YYYY-MM-DD");
  this.filter_end = moment(new Date()).format("YYYY-MM-DD");
  this.filter = [new Date(), new Date()];
 
  this.searchForm.patchValue({
    date: [new Date(), new Date()],
    departmentname: this.departmentid,
    batchname: this.batchid,
    session: this.storageService.getCurrentSession(this.sessionData)?.session
  });
 
  this.findedVal = this.storageService.getCurrentSession(this.sessionData);
 
  if (this.roleId === 5) {
    this.searchForm.controls.departmentname.disable();
    this.searchForm.controls.batchname.disable();
  }
 
  await this.getSubjectDropdown();
  this.Filter();
}

    this.spinner.hide();
  }

  async onSessionChangeEvent(isInitLoad?) {
    this.forms1["date"].setValue(null);
    this.getFilterDate(null);
    let sessionVal = this.forms1["session"].value;
    if (sessionVal) {
      this.findedVal = this.sessionData?.find(
        (list) => list.session === sessionVal
      );
      if (this.findedVal?.start_date && this.findedVal?.end_date) {
        this.minDate.setDate(new Date(this.findedVal.start_date).getDate());
        this.minDate.setMonth(new Date(this.findedVal.start_date).getMonth());
        this.minDate.setFullYear(
          new Date(this.findedVal.start_date).getFullYear()
        );
        this.maxDate.setDate(new Date(this.findedVal.end_date).getDate());
        this.maxDate.setMonth(new Date(this.findedVal.end_date).getMonth());
        this.maxDate.setFullYear(new Date(this.findedVal.end_date).getFullYear());
      }
      await this.getSubjectDropdown();
      if (isInitLoad) {
        this.forms1["date"].setValue([new Date(), new Date()]);
        this.getFilterDate([new Date(), new Date()]);  
      }
    } else {
      this.findedVal = null;
      this.forms1["date"].setValue(null);
      this.getFilterDate(null);
      await this.getSubjectDropdown();
    }
  }

  async getStudentvideoList() {
    this.Studentvideo = [];
    this.spinner.show();
    this.subjectlist = false;
    let filter = {};
    this.route.queryParams.subscribe((params) => {
      this.isLoginType = !!params["loginType"];
      this.globalService.loginType = params.loginType;
      if (params.loginType == "impersonate") {
        this.roleId = this.ls.get("impersonate_role");
        this.departmentid = this.ls.get("impersonate_department_id");
        this.batchid = this.ls.get("impersonate_batch_id");
      } else {
        this.roleId = this.storageService.getRole();
        if (this.roleId == 4) {
          this.professorid = this.ls.get("createdBy");
        } else {
          this.departmentid = this.storageService.getDepartment();
          this.batchid = this.ls.get("batch_id");
        }
      }
      this.batch_id = this.batchid;
      this.department_id = this.departmentid;
      if (this.roleId === 5) {
        this.searchForm?.controls.departmentname.disable();
      }
    });
    if (this.roleId === 5) {
      filter = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        role_id: this.storageService.getRole(),
        page: this.page,
        page_size: this.page_size,
        department_id: this.departmentid,
        subject_id: this.subject_id,
        batch_id: this.batchid,
        professor_id: this.professor_id,
        camera_start: this.filter_from,
        camera_end: this.filter_end,
        session_id: this.findedVal?.id
          ? this.findedVal?.id
          : this.storageService.getCurrentSession(this.sessionData)?.id,
      };
      this.StudentvideoList = await this.globalService.get(
        "classVideoDetail/student/search",
        filter
      );
      if (this.StudentvideoList["status"] === 200) {
        this.Studentvideo = this.StudentvideoList["content"]["rows"];
        this.total = this.StudentvideoList["content"]["count"];
      }
    }
    this.spinner.hide();
  }

  async getDepartment() {
    this.Studentvideo = [];
    this.spinner.show();

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: "5",
    };
    this.department = await this.globalService.get(
      "department/list/dropdown",
      filter,
      true
    );

    this.dept = this.department["content"];
    if (this.roleId === 5) {
      this.filtervalues = true;
      this.searchForm.controls.departmentname.setValue(this.departmentid);
      this.searchForm.controls.departmentname.disable();
    }
    this.spinner.hide();
  }

  getUtcToLocale(dateValue, timeValue, isDateRequested) {
    return this.globalService.getUtcToLocale(dateValue, timeValue, isDateRequested);
  }

  async videoenc(id, hlsStatus) {
    const encrypt = (text) => {
      return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
    };
    const enryptText = hlsStatus == "0" ? "ZERO" : "ONE";
    let key = id;
    if (this.route.queryParams["value"].loginType == "impersonate") {
      window.open(
        `/video/play?key=${key}&loginType=impersonate&isHls=${encrypt(
          enryptText
        )}`,
        "_blank"
      );
    } else {
      window.open(
        `/video/play?key=${key}&isHls=${encrypt(enryptText)}`,
        "_blank"
      );
    }
  }
  async subjectList(batch_id, department_id, subject_id) {
    this.Studentvideo = [];
    this.spinner.show();
    this.subjectlist = true;
    var startUTCDate = moment(this.filter_from, "YYYY-MM-DD");
    var endUTCDate = moment(this.filter_end, "YYYY-MM-DD");
    this.route.queryParams.subscribe((params) => {
      this.isLoginType = !!params["loginType"];
      this.globalService.loginType = params.loginType;
      if (params.loginType == "impersonate") {
        this.roleId = this.ls.get("impersonate_role");
        if (this.roleId == 4)
          this.professorid = this.ls.get("impersonate_user_id");
        else {
          this.departmentid = this.ls.get("impersonate_department_id");
          this.batchid = this.ls.get("impersonate_batch_id");
        }
      } else {
        this.roleId = this.storageService.getRole();
        if (this.roleId == 4) this.professorid = this.ls.get("createdBy");
        else {
          this.departmentid = department_id;
          this.batchid = batch_id;
        }
      }
    });

    if (this.roleId === 4) {
      let filter = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        role_id: this.storageService.getRole(),
        page: this.page,
        page_size: this.page_size,
        professor_id: this.professorid,
        subject_id: subject_id,
        resolution_type: "low",

        camera_start: isNaN(startUTCDate.toDate().getTime())
          ? null
          : startUTCDate.format("YYYY-MM-DD"),
        camera_end: isNaN(endUTCDate.toDate().getTime())
          ? null
          : endUTCDate.format("YYYY-MM-DD"),
      };
      this.StudentvideoList = await this.globalService.get(
        "classVideoDetail/student/search",
        filter
      );
      this.Studentvideo = this.StudentvideoList["content"]["rows"];
      if (this.StudentvideoList["status"] === 200) {
        this.showvideo = true;
      }
      this.prolength = this.StudentvideoList["content"].count;

      this.Studentvideo1 = [];
      this.Studentvideo.map((item) => {
        this.Studentvideo1.push(item);
      });
    }
    if (this.roleId === 5) {
      let filter = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        role_id: this.storageService.getRole(),
        page: this.page,
        page_size: this.page_size,
        department_id: this.departmentid,
        session_id: this.findedVal?.id,
        batch_id: this.batchid,
        subject_id: subject_id,
        professor_id: this.professor_id,
        resolution_type: "low",
      };
      this.StudentvideoList = await this.globalService.get(
        "classVideoDetail/student/search",
        filter
      );
      if (this.StudentvideoList["status"] === 200) {
        this.Studentvideo = this.StudentvideoList["content"]["rows"];
        this.showvideo = true;
      }
      this.prolength = this.StudentvideoList["content"].count;

      this.Studentvideo1 = [];
      this.Studentvideo.map((item) => {
        this.Studentvideo1.push(item);
      });
    }
    this.spinner.hide();
  }

  async getBatch() {
    this.Studentvideo = [];
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.batch = await this.globalService.get(
      "batch/list/dropdown",
      filter,
      true
    );

    this.batchData = this.batch["content"];
    if (this.roleId === 5) {
      this.filtervalues = true;
      this.searchForm.controls.batchname.setValue(this.batchid);
      this.searchForm.controls.batchname.disable();
    }
    this.spinner.hide();
  }

  getFilterDate(filter_date) {
    if (filter_date) {
      this.filter = filter_date;
      this.filter_from = moment(this.filter[0]).format("YYYY-MM-DD");
      this.filter_end = moment(this.filter[1]).format("YYYY-MM-DD");
      var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      var diffDays =
        Math.floor(
          new Date(this.filter_from).getTime() -
            new Date(this.filter_end).getTime()
        ) / oneDay; // hours*minutes*seconds*milliseconds
      var diffDays =
        Math.floor(
          new Date(this.filter_from).getTime() -
            new Date(this.filter_end).getTime()
        ) / oneDay;
      if (-diffDays > 180) {
        Swal.fire({
          text: "Please select dates within 180 days",

          icon: "warning",

          confirmButtonText: "OK",

          confirmButtonColor: "#808080",
        });
        this.searchForm.controls["date"].setValue(""); 
      }
    } else {
      this.filter_from = "";
      this.filter_end = "";
    }
  }
  async getclassroom() {
    this.Studentvideo = [];
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.classroom = await this.globalService.get(
      "classroom/list/dropdown",
      filter,
      true
    );

    this.class = this.classroom["content"];
    this.spinner.hide();
  }
  async getSubject() {
    await this.getSubjectDropdown();
  }
  openScrollableContent(longContent) {
    this.findedVal = null;
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
      this.forms1["session"].setValue(
        this.storageService.getCurrentSession(this.sessionData)?.session
      );
      this.onSessionChangeEvent(true);
    }

    if (this.pageshow === true) {
      this.page_count = [];
      let page_count = Math.ceil(this.total_count / this.page_size);
      if (page_count > 1) {
        this.htmlpageshow = true;
      } else {
        this.htmlpageshow = false;
      }
    }
  }
  increaseShow() {
    // this.page += 1;
    this.getStudentvideoList();
  }

  reset() {
    this.submitted = false;
    this.searchForm.reset();
  }

  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getStudentvideoList();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getStudentvideoList();
  }

  // res() {
  //   this.findedVal = null;
  //   this.filtervalues = false;
  //   this.department_id = null;
  //   this.subject_id = null;
  //   this.classroom_id = null;
  //   this.filter_from = null;
  //   this.filter_end = null;
  //   this.professor_id = null;
  //   this.session_id = null;
  //   this.batch_id = null;
  //   this.filter_date = null;
  //   this.searchForm.reset();
  //   this.page = 1;
  //   this.showvideo = false;
  //   this.viewvideo = false;
  //   this.getStudentvideoList();
  //   if (this.storageService.getRole() != 4 && this.hod != 1) {
  //     this.department_id = null;
  //     this.batch_id = null;
  //   }
  // }

  async res() {
    this.findedVal = null;
    this.filtervalues = false;

    this.department_id = null;
    this.subject_id = null;
    this.classroom_id = null;
    this.professor_id = null;
    this.session_id = null;
    this.batch_id = null;
    this.filter_from = moment(new Date()).format("YYYY-MM-DD");
    this.filter_end = moment(new Date()).format("YYYY-MM-DD");
    this.filter = [new Date(), new Date()];

    this.searchForm.reset();

    this.departmentid = this.storageService.getDepartment();
    this.batchid = this.ls.get("batch_id");

    await this.getProfessor(true);
    await this.getSubjectDropdown();

    this.searchForm.patchValue({
      departmentname: this.department_id || this.departmentid,
      depname: this.department_id || this.departmentid,
      batchname: this.batchid,
      session: this.storageService.getCurrentSession(this.sessionData)?.session
    });
    this.findedVal = this.storageService.getCurrentSession(this.sessionData);

    // Disable again for Role 5 if not allowed to search all videos
    if (this.roleId === 5 && this.is_student_search_all_video != "1") {
      this.searchForm.controls["departmentname"]?.disable();
      this.searchForm.controls["batchname"]?.disable();
    }

    this.page = 1;
    this.showvideo = false;
    this.viewvideo = false;

    if (this.storageService.getRole() != 4 && this.hod != 1) {
      this.department_id = null;
      this.batch_id = null;
    }

    this.Filter();
  }
 
  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getStudentvideoList();
  }
}
